import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import Modal from "../Reusable/Modal";
import SwitchButton from "../Reusable/SwitchButton";
import SyncContact from "./SyncContact";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";

const MerchantList = (props: any) => {
  const {
    handleIsActive,
    handleIsEnableEmail,
    handleIsEnableSMS,
    handleIsEnableSummary,
    handleIsEnableSenderSMS,
    handleIsEnableSenderEmail,
  } = props;
  const [openSyncContactPopUp, setOpenSyncContactPopup] = useState(false);
  const { isSuperUser } = usePermission();
  const navigate = useNavigate();

  const canEditMerchant = usePermission({
    allowedPermissions: ["can_update_merchant"],
  });

  const handleRowClick = (row: any) => {
    if (!canEditMerchant) return;
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "user.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user.email",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user.mobile_number",
      cell: NACell,
    },
    {
      header: "Sender SMS",
      accessorKey: "receive_sms",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSenderSMS}
          />
        </div>
      ),
    },
    {
      header: "Receiver SMS",
      accessorKey: "is_enable_sms",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSMS}
          />
        </div>
      ),
    },

    {
      header: "Sender Email",
      accessorKey: "receive_email",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSenderEmail}
          />
        </div>
      ),
    },
    {
      header: "Reciever Email",
      accessorKey: "is_enable_email",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableEmail}
          />
        </div>
      ),
    },
    {
      header: "Order Summary",
      accessorKey: "is_summary_email",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSummary}
          />
        </div>
      ),
    },
    {
      header: "Active",
      accessorKey: "user.is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.user?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_merchant"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.user?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <AccessControl
        allowedPermissions={["can_view_merchant"]}
        children={
          <DataTable
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            columns={defaultColumns}
            addNewPagePath={"create"}
            tableName={"merchant-list"}
            actionMenu={
              <>
                <div className={tw`flex items-center justify-end w-full `}>
                  <div className={tw`w-24 text-primary`}></div>
                </div>
              </>
            }
            onRowClick={handleRowClick}
          />
        }
      />

      <Modal
        title={"Sync Contact"}
        isOpen={openSyncContactPopUp}
        setIsOpen={setOpenSyncContactPopup}
      >
        <SyncContact setOpenSyncContactPopup={setOpenSyncContactPopup} />
      </Modal>
    </>
  );
};

export default MerchantList;
